import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';

export const InitialStudentTransportDetailState = {
    status: true,
    area_id: null,
    zone_id: null,
    transport_type_id: null,
    morning_bus_id: null,
    evening_bus_id: null,
    remarks: null,
    start_date: null,
    end_date: null
};

export const StudentTransportDetailSchema = Yup.object().shape({
    start_date: Yup.date().required(),
    end_date: Yup.date().required(),
    remarks: Yup.string().nullable(),
    status: Yup.boolean().required(),
    area_id: Yup.number().required(),
    zone_id: Yup.number().required(),
    transport_type_id: Yup.number().required(),
    morning_bus_id: Yup.number().nullable(),
    evening_bus_id: Yup.number().nullable(),
});

export const StudentTransportDetailFormFields = [
    { name: "transport_type_id", title: "Transport Type", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "type", itemValue: "id" },
    { name: "zone_id", title: "Zone", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "area_id", title: "Area", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "morning_bus_id", title: "Morning Bus", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "bus_number", itemValue: "id" },
    { name: "evening_bus_id", title: "Evening Bus", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "bus_number", itemValue: "id" },
    { name: "start_date", title: "Start Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "end_date", title: "End Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "remarks", title: "Remarks", required: false, type: VALUE_TYPES.TEXT },
    { name: "status", title: "Status", required: true, type: VALUE_TYPES.SWITCH, options: [{ title: "Active", id: true }, { title: "In-Active", id: false }] },
];
